import { Component, OnInit } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { DepartmentsService } from '../../../service/departments.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Role } from 'src/app/lem/models/common/role';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { ModalRoleComponent } from '../../../components/modal-role/modal-role.component';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-gestione-ruoli',
  templateUrl: './gestione-ruoli.component.html',
  styleUrls: ['./gestione-ruoli.component.css']
})
export class GestioneRuoliComponent implements OnInit {

  roles : PaginatedResponse<Role>;
  resetCurrentPage: boolean = false;
  pagable:Pagable;

  constructor(private modal : DialogService,
    private departmentsService : DepartmentsService,
    private viewManager : ViewManagerService) { }

  ngOnInit() {
    this.pagable = new Pagable();
    this.getAllRoles()
  }


  onEdit(role: Role){
    const ref = this.modal.open(ModalRoleComponent,{
      data : {
        role : role,
        style: {width: "50%"},
        formSettings : {
          formEdit : true,
          formData : ""
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  onDelete(role: Role){
    const ref = this.modal.open(ConfirmModalComponent,{
      data : {
        modalConfirm:{

          text:"Eliminare il ruolo  " + role.name + "?" ,
          data : role,
        },
        style: {width: "30%"},
        title:"Eliminazione ruolo",
      }
    })
    this.modalCloseEvent(ref);
  }

  addRole () {
    const ref = this.modal.open(ModalRoleComponent,{
      data : {
        style: {width: "50%"},
        formSettings : {
          formEdit : false,
          formData : ""
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  modalCloseEvent(ref: DialogRef) {
    ref.afterClosed.pipe(
      filter(response => response)
    ).subscribe((data)=> {
      if (data.save){
        this.departmentsService.addRole(data.data)
          .pipe(
            map(data => this.getAllRoles())
          ).subscribe();
      } else if(data.modalEvent){
        this.departmentsService.deleteRole(data.data.id)
          .pipe(
            map(data => this.getAllRoles())
          ).subscribe();
      }
    });
  }

  private getAllRoles() {
    this.departmentsService.getAllRoles(undefined,undefined,this.pagable).subscribe({
      next: (data) => {
        this.roles = data;
      },
      error: () => { }
    });
  }

  retrievePagable(pagable:Pagable){
    this.pagable = pagable;
    this.getAllRoles();
  }

  refresh(pagination?: Pagination) {
    if(pagination){
      this.pagable.page = pagination.getCurrentPage();
      this.pagable.size = pagination.getItemsPerPage();
    }
    this.getAllRoles();
    this.resetCurrentPage = false;
  }
}
